import React from 'react';
import styled from '@emotion/styled';
import type { FontSizeProps, LineHeightProps } from 'styled-system';
import { fontSize, lineHeight, space, themeGet } from 'styled-system';

import { useLocalization } from '../providers/LocaleProvider';
import { focusOutlineCSSWithOffset } from '../theme/styles';
import type { SpaceProps } from '../theme/system-types';
import { linkStyles } from './Link';
import { CaptionRegularCR1 } from './Typography';

type CustomProps = SpaceProps & FontSizeProps & LineHeightProps;

const StyledCaption = styled(CaptionRegularCR1)<CustomProps & { styled: boolean }>`
  ${space};
  ${fontSize};
  ${lineHeight};

  a {
    ${linkStyles};
    ${focusOutlineCSSWithOffset};
    border-radius: ${themeGet('radii.small')};
    color: ${themeGet('colors.sys.neutral.border.strong')};
    text-decoration: underline;
  }
`;

export const HomeClubLegalText = ({ ...props }: CustomProps) => {
  const { r, p, t } = useLocalization();

  return (
    <StyledCaption
      {...props}
      as="p"
      styled={true}
      dangerouslySetInnerHTML={{
        __html: r.t('h24_hc_registration_page_legal_terms', {
          terms_href: p(t('h24_hc_modal_disclaimer_conditions_href')),
          data_protection_href: p(t('h24_hc_modal_disclaimer_data_protection_href')),
        }),
      }}
    />
  );
};
